var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xB8\xD0\xBA\xD0\xBE\xD0\xBD\xD0\xBA\xD0\xB0 \xD0\xBF\xD0\xBE\xD0\xB8\xD1\x81\xD0\xBA_icon search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.22796 13.4559C10.6676 13.4559 13.4559 10.6676 13.4559 7.22797C13.4559 3.78836 10.6676 1 7.22796 1C3.78835 1 1 3.78836 1 7.22797C1 10.6676 3.78835 13.4559 7.22796 13.4559Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2286 16.6959L12.2924 13.7597C11.8869 13.3542 11.8869 12.6968 12.2924 12.292C12.6979 11.8865 13.3553 11.8865 13.7601 12.292L16.6963 15.2281C17.1018 15.6336 17.1018 16.291 16.6963 16.6959C16.2908 17.1014 15.6334 17.1014 15.2286 16.6959Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2932 12.2917L11.6289 11.6291",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/whiteSearch.385b0b6614d31530baacc28769541311.svg";
export { ForwardRef as ReactComponent };